<template></template>

<script>

import AppService from "../../services/AppService";

export default {
  name: "Biometria",
  created() {
    sessionStorage.clear();
    this.$store.dispatch('resetState');
    this.$store.dispatch('setLoadingStatus',true);
    this.appService = new AppService();
  },
  mounted() {
   let codigo = this.$route.params.codigo;
   let hrefer = (document.referrer) ? document.referrer : this.montarLink(); 
   let origem = window.location.href;

      if(!codigo || !origem || !hrefer){
        this.error('URL inválida');
        return;
      }

      this.$store.dispatch('recuperarDadosLinkMeuVivo',{codigo,hrefer,origem})
          .then(() => {
            sessionStorage.setItem('k',btoa(JSON.stringify({
              codigo,
              hrefer
            })));
            this.$router.push({name: 'ConfirmarIdentidade'});
          })
          .catch(error => this.error(error));
  },
  methods:{
    montarLink:function (){
      let protocol = window.location.protocol;
      let hostname = window.location.hostname;
      let codigo = this.$route.params.codigo;
      let part =  process.env.PART_URL;
      return `${protocol}//${hostname}${part}/link/meuvivo/${codigo}`;
    },
    error:function (description){
      if(!description){
        description = 'Falha ao recuperar dados do link';
      }
      sessionStorage.setItem('error_message',description);
      this.$router.push({name: 'Falha'});
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Biometria.vue